import { defineMeta } from '@/registry/types';

export const formPageLayoutMeta = defineMeta({
  name: 'FormPageLayout',
  level: 'template',
  category: 'layout',
  classification: 'custom',
  description: 'Centered single-column form page with header and footer action bar.',
  baseLibrary: 'custom',
  a2uiEquivalent: 'FormPage',
  importPath: '@/templates/FormPageLayout',
  requiredProps: ['title', 'children'],
  optionalProps: ['description', 'actions', 'maxWidth'],
  supportedStates: ['default'],
  designTokens: ['spacing', 'typography'],
  accessibility: ['Title is the page heading; group fields with FormSection/FormField.'],
  usageExamples: ['<FormPageLayout title="Connect" actions={<Button>Save</Button>}>...</FormPageLayout>'],
  antiPatterns: ['Do not use for multi-step wizards (add a Stepper).'],
  llmSafe: true,
  whenToUse: ['Create/edit single-entity forms'],
  whenNotToUse: ['Tables/dashboards'],
});

export default formPageLayoutMeta;
